export default function ResultHeader({children, style = {}, ...props}) {

    return (
        <thead style={{fontWeight: 'bold', ...style}} {...props}>
        {children}
        </thead>
    )
}